export default __webpack_public_path__ + "static/media/logo_full.c1e5fa84.svg";